 // eslint-disable-next-line
import { brand } from '../../../theme/themePrimitives';
import CardWrapper from '../../wrapper/card';
import EditTitleModal from '../modal/edit_title';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { changeStatusUserFormThunk, createUserFormThunk, editUserFormThunk, saveAsTemplateUserFormThunk } from '../../../redux/thunks/form';
import { EditOutlined, KeyboardArrowLeft } from '@mui/icons-material';
import { resettingFormData, settingCreateFormFlag, settingFormSettingsFlag, settingPreviewFlag } from '../../../redux/slices/form';
import { useDispatch, useSelector } from 'react-redux';

const CreateFormHeaderComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const { formFields, preview, loaders, selectedForm, settings } = useSelector((state: RootState) => state.form);
    const [showModal, setShowModal] = useState<boolean>(false);

    const navigateBackHandler = () => {
        if (settings) {
            dispatch(settingFormSettingsFlag(false));
        } else if (preview) {
            dispatch(settingPreviewFlag(false));
        } else {
            dispatch(settingCreateFormFlag(false));
        }
    };

    const handleViewAndPublishButton = async () => {
        if (settings) {
            dispatch(settingFormSettingsFlag(false));
            dispatch(settingPreviewFlag(true));
        } else if (preview) {
            try {
                if (formFields.isEditing) {
                    await dispatch(editUserFormThunk()).unwrap();
                    await dispatch(changeStatusUserFormThunk('active')).unwrap();
                } else {
                    await dispatch(createUserFormThunk({ client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
                }
                dispatch(resettingFormData());
            } catch (e) {
                // catch errors
            }
        } else {
            dispatch(settingPreviewFlag(true));
        }
    };

    const saveAsTemplateHandler = async () => {
        try {
            if (selectedForm?.id) {
                await dispatch(changeStatusUserFormThunk('draft')).unwrap();
            } else {
                await dispatch(saveAsTemplateUserFormThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
            }
            dispatch(resettingFormData());
        } catch (e) {
            //
        }
    };

    const moveToSettingsHandler = () => {
        dispatch(settingFormSettingsFlag(true));
        dispatch(settingPreviewFlag(false));
    };

    return (
        <CardWrapper>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Button variant="text" color="secondary" disabled={loaders.isCreating || loaders.isUpdating} onClick={navigateBackHandler}><KeyboardArrowLeft /> {preview ? 'Go Back to Editor' : 'Back'}</Button>
                <Box display="flex" gap={1} alignItems="center">
                    <IconButton disabled={loaders.isCreating || loaders.isUpdating} color="primary" onClick={() => setShowModal(true)}>
                        <EditOutlined />
                    </IconButton>
                    <Typography variant="h5" color={brand[300]}>{formFields.formTitle}</Typography>
                </Box>
                <Box display="flex" gap={1}>
                    <Button variant="outlined" disabled={loaders.isCreating || loaders.isUpdating || settings} onClick={moveToSettingsHandler}>Settings</Button>
                    <Button variant="outlined" color="secondary" disabled={loaders.isCreating || loaders.isUpdating} onClick={saveAsTemplateHandler}>Save Draft</Button>
                    <Button variant="contained" color="primary" disabled={loaders.isCreating || loaders.isUpdating || (formFields.fields.length === 0 && preview)} onClick={handleViewAndPublishButton}>{preview ? 'Publish' : 'Preview & Publish'}</Button>
                </Box>
            </Box>
            <EditTitleModal open={showModal} onClose={() => setShowModal(false)} />
        </CardWrapper>
    );
};

export default CreateFormHeaderComponent;